import {Component} from '@angular/core';

@Component({
  selector: 'sales-portal-header',
  templateUrl: './sales-portal-header.component.html',
  styleUrls: ['./sales-portal-header.component.less']
})
export class SalesPortalHeaderComponent {
  language: string = "en";
}

